var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_cof.js
// module id = 92
// module chunks = 0